import { Helmet } from 'react-helmet-async';
import HeroSection from '../components/home/HeroSection';
import StatsBar from '../components/home/StatsBar';
import MediaSlider from '../components/home/MediaSlider';
import VideoSection from '../components/home/VideoSection';
import RealEstateMadeSimple from '../components/home/RealEstateMadeSimple';
import HowItWorks from '../components/home/HowItWorks';
import PartnersSection from '../components/home/PartnersSection';
import StructuredData from '../components/common/StructuredData';

export default function Home() {
  return (
    <>
      <Helmet>
        <title>RentFi | Earn Monthly Passive Income from Real Estate Investment</title>
        <meta 
          name="description" 
          content="Invest in premium real estate properties through RentFi and earn monthly passive income. Our blockchain-powered platform enables fractional property investment with yields up to 12.88% annually." 
        />
        <meta 
          name="keywords" 
          content="real estate investment, blockchain real estate, passive income, property investment, RENT token, RentFi, monthly rental income" 
        />
        <link rel="canonical" href="https://rentfi.io" />
      </Helmet>
      <StructuredData />
      <div>
        <HeroSection />
        <StatsBar />
        <MediaSlider />
        <VideoSection />
        <RealEstateMadeSimple />
        <PartnersSection />
        <HowItWorks />
      </div>
    </>
  );
}